import React, { lazy, Suspense } from 'react';
import ReactGA from 'react-ga4';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import './AppOutput.css';
import SiteLayout from './portfolio/SiteLayout';
import { HomePage, ProjectsPage, WritingPage, NotFoundPage } from './portfolio/PortfolioPages';
import ArticlePage from './portfolio/ArticlePage';
import './utils/fetchInterceptor';

// Keep the existing tools at their original URLs, outside the editorial layout.
const IncidentCounter = lazy(() => import('./components/IncidentCounter'));
const EveryDay = lazy(() => import('./components/EveryDay'));
const YearlyInterview = lazy(() => import('./yearly_interview/YearlyInterview'));
const SavedSearch = lazy(() => import('./saved_search/SavedSearch'));
const PoetryGame = lazy(() => import('./poetry_game/PoetryGame'));
const Minutes = lazy(() => import('./minutes/Minutes'));
const TriedEverything = lazy(() => import('./components/TriedEverything'));
const SleepResetChallenge = lazy(() => import('./components/SleepSuiteFM'));
const PerfHome = lazy(() => import('./components/Perf').then(m => ({ default: m.PerfHome })));
const PerfPrivacy = lazy(() => import('./components/Perf').then(m => ({ default: m.PerfPrivacy })));
const AttentionSpan = lazy(() => import('./components/AttentionSpan'));
const LegacyPost = lazy(() => import('./components/MarkdownPost'));
const analyticsEnabled = ['www.sashachisler.com', 'sashachisler.com'].includes(window.location.hostname);
if (analyticsEnabled) ReactGA.initialize('G-0LQLNLFQSF');

function RouteTracker() {
    const location = useLocation();
    React.useEffect(() => {
        if (analyticsEnabled) ReactGA.send({ hitType: 'pageview', page: location.pathname });
    }, [location]);
    return null;
}
export default function App() {
    return <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <RouteTracker />
        <Suspense fallback={<p style={{ padding: 32 }} role="status">Loading…</p>}>
            <Routes>
                <Route element={<SiteLayout />}>
                    <Route index element={<HomePage />} />
                    <Route path="/projects" element={<ProjectsPage />} />
                    <Route path="/projects/:slug" element={<ArticlePage kind="project" />} />
                    <Route path="/writing" element={<WritingPage />} />
                    <Route path="/posts/:slug" element={<ArticlePage kind="writing" />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Route>
                <Route path="/posts/ukraine_aid" element={<Navigate to="/projects/ukraine-aid" replace />} />
                <Route path="/posts/godswork" element={<Navigate to="/projects/godswork" replace />} />
                <Route path="/posts/doing_nothing_3_hours" element={<Navigate to="/projects/do-nothing" replace />} />
                <Route path="/posts/phone_diet_7_days" element={<Navigate to="/projects/the-experiment" replace />} />
                <Route path="/posts/attention_apps" element={<Navigate to="/projects/the-experiment#tools" replace />} />
                <Route path="/posts/attention_research" element={<LegacyPost />} />
                <Route path="/incident-counter" element={<IncidentCounter />} />
                <Route path="/daily" element={<EveryDay />} />
                <Route path="/daily/:username" element={<EveryDay />} />
                <Route path="/yearly-interview" element={<YearlyInterview />} />
                <Route path="/saved-search" element={<SavedSearch />} />
                <Route path="/poetry-game" element={<PoetryGame />} />
                <Route path="/varya-12-birthday" element={<Minutes />} />
                <Route path="/tried-everything" element={<TriedEverything />} />
                <Route path="/sleep-reset-challenge" element={<SleepResetChallenge />} />
                <Route path="/perf" element={<PerfHome />} />
                <Route path="/perf/privacy" element={<PerfPrivacy />} />
                <Route path="/attention" element={<AttentionSpan />} />
            </Routes>
        </Suspense>
    </Router>;
}
